import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Input,
  Label,
  Form,
  FormFeedback,
} from "reactstrap"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"
import { GoogleOAuthProvider } from "@react-oauth/google"
import EmailOtp from "./EmailOtpPopUp"
// action
import {
  registerUser,
  apiError,
  verifyOtpErrorReset,
  registerUserReset,
  gLoginStart,
} from "../../store/actions"
import withRouter from "components/Common/withRouter"
//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import { Link, useNavigate } from "react-router-dom"

// import images
import profileImg from "../../assets/images/profile-img.png"
import logoImg from "../../assets/images/logo.svg"
import Otp from "./OtpPopUp"
import { toast } from "react-toastify"
import PropTypes from "prop-types"
const Register = props => {
  //meta title
  document.title = "Register | Wwings Smart Technology"

  const [inputOTP, setInputOTP] = useState("")
  const [showAlert, setShowAlert] = useState({
    visible: false,
    message: "",
    type: "",
  })
  const [otpVerify, setOtpVerified] = useState(false);
  const [inputLength, setInputLength] = useState(0);
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const selectAccountState = state => state.Account
  const AccountProperties = createSelector(selectAccountState, account => ({
    user: account.user,
    registrationError: account.registrationError,
    success: account.success,
    // loading: account.loading,
  }))

  const {
    user,
    registrationError,
    success,
    // loading
  } = useSelector(AccountProperties)

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: "",
      mobno: "",
      email: "",
      // username: '',
      password: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Your Name"),
      mobno: Yup.string()
        .required("Please Enter Your Phone Number")
        .matches(/^\d{10}$/, "Phone number must be 10 digits"),
      email: Yup.string().required("Please Enter email"),
      // username: Yup.string().required("Please Enter Your Username"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: values => {
      if (otpVerified) {
        dispatch(registerUser(values))
      } else {
        setShowAlert({
          visible: true,
          message: "Please Verify Otp First",
          type: "danger",
        })
        setTimeout(() => {
          setShowAlert({ visible: false, message: "", type: "" })
        }, 2000)
      }
    },
  })
  useEffect(() => {
    setInputLength(validation.values.mobno.length);
  }, [validation.values.mobno]);

  const verifyOtpState = state => state.otpReducer
  const verifyOtpProperties = createSelector(verifyOtpState, otp => ({
    verifyOtpError: otp.verifyOtpError,
    otpVerified: otp.otpVerified,
    sendOTPLoading: otp.loading,
    otpResponseMessage: otp.otpResponseMessage,
    verifyOTPLoading: otp.verifyLoading,
  }))

  const {
    verifyOtpError,
    otpVerified,
    sendOTPLoading,
    otpResponseMessage,
    verifyOTPLoading,
  } = useSelector(verifyOtpProperties)

  useEffect(() => {
    dispatch(apiError(""))
    dispatch(verifyOtpErrorReset())
    dispatch(registerUserReset())
  }, [])

  useEffect(() => {
    success && setTimeout(() => navigate("/login"), 2000)
  }, [success])

  window.handleCredentialResponse = response => {
    // decodeJwtResponse() is a custom function defined by you
    // to decode the credential response.
    dispatch(
      gLoginStart({ access_token: response.credential }, props.router.navigate)
    )
  }
  useEffect(() => {
    toast.error(verifyOtpError)
  }, [verifyOtpError])

  const GoogleLoginState = state => state.GloginReducer
  const GoogleProperties = createSelector(GoogleLoginState, Glogin => ({
    GLoginerror: Glogin.error,
  }))
  const { GLoginerror } = useSelector(GoogleProperties)
  useEffect(() => {
    if (GLoginerror && GLoginerror.length > 0) {
      toast.error(GLoginerror)
    }
  }, [GLoginerror])

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="bx bx-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Register Here</h5>
                        <p>Register for Wwings Technology now.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profileImg} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logoImg}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div>
                    {verifyOtpError && (
                      <Alert color="danger">{verifyOtpError}</Alert>
                    )}
                    {showAlert.visible && (
                      <Alert color={showAlert.type}>{showAlert.message}</Alert>
                    )}
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      {user && user ? (
                        <Alert color="success">
                          User Registered Successfully
                        </Alert>
                      ) : null}

                      {registrationError && registrationError ? (
                        <Alert color="danger">{registrationError}</Alert>
                      ) : null}
                      <div className="mb-3">
                        <Label className="form-label">Name</Label>
                        <Input
                          id="text"
                          name="name"
                          className="form-control"
                          placeholder="Enter your Name"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.name || ""}
                          invalid={
                            validation.touched.name && validation.errors.name
                              ? true
                              : false
                          }
                        />
                        {validation.touched.name && validation.errors.name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.name}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <div>
                          <Label className="form-label">Email</Label>
                          <Input
                            name="email"
                            type="email"
                            className="form-control"
                            placeholder="Enter email"
                            onChange={validation.handleChange}
                            value={validation.values.email}
                          />
                        </div>
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">WhatsApp Number</Label>
                        <Input
                          id="text"
                          name="mobno"
                          className="form-control"
                          placeholder="Enter phone number"
                          type="number"
                          onChange={(e) => {
                            const input = e.target.value;
                            if (input.length <= 10) {
                              validation.handleChange(e);
                            }
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.mobno || ""}
                          invalid={
                            validation.touched.mobno && validation.errors.mobno
                              ? true
                              : false
                          }
                        />
                        {validation.touched.mobno && validation.errors.mobno ? (
                          <FormFeedback type="invalid">
                            {validation.errors.mobno}
                          </FormFeedback>
                        ) : null}
                      </div>

                      {validation.values.mobno && (
                        <Otp
                          setInputOTP={setInputOTP}
                          inputOTP={inputOTP}
                          phone_no={validation.values.mobno}
                          otpResponseMessage={otpResponseMessage}
                          verifyOTPLoading={verifyOTPLoading}
                          verifyOtpError={verifyOtpError}
                          sendOTPLoading={sendOTPLoading}
                          otpVerified={otpVerified}
                        />
                      )}
                      <br />
                      {/* <div className="mb-3">
                        <Label className="form-label">Username</Label>
                        <Input
                          name="username"
                          type="text"
                          placeholder="Enter username"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.username || ""}
                          invalid={
                            validation.touched.username && validation.errors.username ? true : false
                          }
                        />
                        {validation.touched.username && validation.errors.username ? (
                          <FormFeedback type="invalid">{validation.errors.username}</FormFeedback>
                        ) : null}
                      </div> */}
                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <Input
                          name="password"
                          type="password"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.password || ""}
                          invalid={
                            validation.touched.password &&
                              validation.errors.password
                              ? true
                              : false
                          }
                        />
                        {validation.touched.password &&
                          validation.errors.password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mt-4 ">
                        <div className="d-flex align-items-center justify-content-center">
                          <button
                            className="btn btn-primary btn-block w-50"
                            type="submit"
                          >
                            Register
                          </button>
                        </div>
                        {/* <div className="mt-3 text-center">
                          {" "}
                          <h5 className="font-size-16 font-weight-bold mb-3">
                            Or
                          </h5>
                        </div>
                        <div className="btn d-flex align-items-center justify-content-center">
                          <GoogleOAuthProvider>
                            <div
                              id="g_id_onload"
                              // data-client_id="166210336438-fjofd1s6sbabl0a9ecrbdughbj98krgd.apps.googleusercontent.com"
                              data-client_id={
                                process.env.REACT_APP_GOOGLE_AUTH_CLIENT
                              }
                              data-context="signin"
                              data-ux_mode="popup"
                              data-callback="handleCredentialResponse"
                              data-auto_prompt="false"
                            ></div>

                            <div
                              className="g_id_signin"
                              data-type="standard"
                              data-shape="rectangular"
                              data-theme="outline"
                              data-text="signin_with"
                              data-size="large"
                              data-logo_alignment="left"
                            ></div>
                          </GoogleOAuthProvider>
                        </div> */}
                      </div>

                      <div className="mt-4 text-center">
                        <p className="mb-0">
                          By registering you agree to the Wwings{" "}
                          <Link to="/TermsAndCondition" className="text-primary">
                            Terms of Use
                          </Link>
                        </p>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Already have an account ?{" "}
                  <Link to="/login" className="font-weight-medium text-primary">
                    {" "}
                    Login
                  </Link>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} Designed and developed{" "}
                  <i className="mdi mdi-heart text-danger" /> by Wwings Smart
                  Technology
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

//export default Register

export default withRouter(Register)

Register.propTypes = {
  history: PropTypes.object,
}
